module.exports = __webpack_public_path__ + "assets/img/00090.9116464b.png";